import React, {Dispatch, SetStateAction, useContext, useEffect, useRef, useState} from "react";
import {COMMON_MODAL_STYLE} from "../../../helper/StyleHelper";
import {Col, Modal, Row, Table} from "react-bootstrap";
import {IoMdClose} from "react-icons/io";
import Datatables, {getCheckedItems} from "../../component/Datatables";
import axios from "axios";
import {toast} from "react-toastify";
import messageCodeDic from "../../../util/messageCodeDic";
import BMCSelect from "../../../components/common/BMCSelect";
import {getLoginUser} from "../../../helper/SecurityHelper";
import SHSearch from "../../component/BMCSearch";
import BMCInput from "../../../components/common/BMCInput";
import restapi from "../../../helper/restAPIHelper";
import SiteSftyChkRgstModal from "../../safetyWorkReportManagement/modal/SiteSftyChkRgstModal";
import SiteManageRgstModal from "../../headManage/modal/SiteManageRgstModal";
import {SiteContext} from "../../../context/Site";
import SafetyNewspaperModal from "../../safetyNewspaper/modal/SafetyNewspaperModal";
import errorCodeDic from "../../../util/errorCodeDic";
import {ProgressContext} from "../../../context/Progress";
import NoticeRegistModal from "../../noticeManagement/modal/NoticeRegistModal";
import IncgrtyRgstModal from "../../siteSafetyManagement/modal/IncgrtyRgstModal";
import WrkPrmtRgstModal from '../../siteSafetyManagement/modal/WrkPrmtRgstModal';
import RskAsmntRgstModal from '../../siteSafetyManagement/modal/RskAsmntRgstModal';
import { UserContext } from '../../../context/User';
import DailySftyRprtRgstModal from '../../safetyWorkReportManagement/modal/DailySftyRprtRgstModal';

interface IProps {
    setModalIsOpen: Dispatch<SetStateAction<boolean>>;
    modalIsOpen: boolean;
    dataList: object[];
    siteId?: any;

}

const $ = require("jquery")

const RcvNtfyListModal = (props: IProps) => {
    const [datatable, setDatatable] = useState<any>();

    const [isCodeDataLoaded, setIsCodeDataLoaded] = useState<any>(null);
    const [dataList, setDataList] = useState<any>([]);
    const [isNewsPprModalOpen, setIsNewsPprModalOpen] = useState<boolean>(false);
    const [detailData, setDetailData] = useState<any>({});
    const {spinner} = useContext(ProgressContext);
    const user = getLoginUser();
    const {defaultUser} = useContext<any>(UserContext);
    const [isNoticeModalOpen, setIsNoticeModalOpen] = useState<boolean>(false);
    const [isIncgrtyModalOpen, setIsIncgrtyModalOpen] = useState<boolean>(false);
    const [isSftyChkModalOpen, setIsSftyChkModalOpen] = useState<boolean>(false);
    const [wrkModalIsOpen, setWrkModalIsOpen] = React.useState(false);
    const [rskModalIsOpen, setRskModalIsOpen] = React.useState(false);
    const [modalRgstIsOpen, setModalRgstIsOpen] = React.useState(false);

    useEffect(() => {
        if (isCodeDataLoaded) {
            fn_search();
        }
    }, [isCodeDataLoaded]);

    function fn_closeModal() {
        props.setModalIsOpen(false);
    }

    const fn_search = (e?: any) => {
        e?.preventDefault()
        datatable?.draw()
    }

    const fn_onShow = () => {

        setDataList(props.dataList);
    }

    const fn_openDtlPop = (data: any) => {

        console.log('pop data: ', data);
        const rcvNtfyGb = data.rcvNtfyGb;

        // 안전 신고 포상
        if(rcvNtfyGb == 'R002001'){
            spinner.start();
            restapi.retrieveSftyNwspprTotDataList({sftyNwspprId: data.rcvNtfyId}).then((rsltData: any) => {

                setDetailData(rsltData[0]);
                setIsNewsPprModalOpen(true);
                fn_readRcvNtfy(data);
            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
                .finally(() => {
                    spinner.stop();
                });
        // 공지사항
        }else if(rcvNtfyGb == 'R002002'){
            spinner.start();
            restapi.retrieveNoticeDataTotList({noticeId: data.rcvNtfyId}).then((rsltData: any) => {

                setDetailData(rsltData[0]);
                setIsNoticeModalOpen(true);
                fn_readRcvNtfy(data);
            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
                .finally(() => {
                    spinner.stop();
                });
        }else if(rcvNtfyGb == 'R002003'){
            spinner.start();
            restapi.retrieveIncgrtyDataTotList({incgrtyId: data.rcvNtfyId}).then((rsltData: any) => {

                setDetailData(rsltData[0]);
                setIsIncgrtyModalOpen(true);
                fn_readRcvNtfy(data);
            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
                .finally(() => {
                    spinner.stop();
                });
        }else if(rcvNtfyGb == 'R002004'){
            spinner.start();
            restapi.retrieveSiteSftyManageDataTotList({sftyChkSeq: data.rcvNtfyId}).then((rsltData: any) => {

                setDetailData(rsltData[0]);
                setIsSftyChkModalOpen(true);
                fn_readRcvNtfy(data);
            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
                .finally(() => {
                    spinner.stop();
                });
        }else if(rcvNtfyGb == 'R002006') {
            spinner.start();
            axios.post('/admin/api/rskAsmnt/retrieveRskAsmntDataList', {
                siteId: data.siteId, riskAsmntId: data.rcvNtfyId
            }).then((result) => {
                setDetailData(result.data[0])
                setRskModalIsOpen(true);
                fn_readRcvNtfy(data);
            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
                .finally(() => {
                    spinner.stop();
                });
        }else if(rcvNtfyGb == 'R002007') {
            spinner.start();
            axios.post('/admin/api/wrkPrmt/retrieveWrkPrmtDataList', {
                siteId: data.siteId, wrkPrmtId: data.rcvNtfyId
            }).then((result) => {
                setDetailData(result.data[0])
                setWrkModalIsOpen(true);
                fn_readRcvNtfy(data);
            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
                .finally(() => {
                    spinner.stop();
                });
        }else if(rcvNtfyGb == 'R002008') {
            spinner.start();
            axios.post('/admin/api/dailySftyRprt/retrieveDailySftyRprtDataList', {
                siteId: data.siteId, sftyRprtSeq: data.rcvNtfyId
            }).then((result) => {
                setDetailData(result.data[0]);
                setModalRgstIsOpen(true);
                fn_readRcvNtfy(data);
            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
                .finally(() => {
                    spinner.stop();
                });
        }
    }

    const fn_readRcvNtfy = (param: any) => {

        if(!param.isRead){
            param.userSeq = user.userSeq;
            restapi.insertRcvNtfyReadData(param).then((rsltData: any) => {
                if(user.authGrpId == 'SITE'){
                    restapi.retrieveSiteRcvNtfyDataList({userSeq: user.userSeq, blngCmpnySeq: user.blngCmpnySeq, siteId: props.siteId}).then((rsltData: any) => {
                        setDataList(rsltData);
                    })
                }else{
                    restapi.retrieveHeadRcvNtfyDataList({userSeq: user.userSeq}).then((rsltData: any) => {
                        setDataList(rsltData);
                    })
                }

            }).catch(error => {
                toast.error(errorCodeDic['003']);
                console.log('error: ', error);
            })
        }
    }

    return (
        <div>
            <SafetyNewspaperModal setModalIsOpen={setIsNewsPprModalOpen} modalIsOpen={isNewsPprModalOpen} detailData={detailData} isCommentMode={false}/>
            <NoticeRegistModal setModalIsOpen={setIsNoticeModalOpen} modalIsOpen={isNoticeModalOpen} siteId={props.siteId}
                               noticeDetailData={detailData} />
            <IncgrtyRgstModal setModalIsOpen={setIsIncgrtyModalOpen} modalIsOpen={isIncgrtyModalOpen} siteId={props.siteId}
                              detailData={detailData}/>
            <SiteSftyChkRgstModal setModalIsOpen={setIsSftyChkModalOpen} modalIsOpen={isSftyChkModalOpen} prcsGb={'actRgst'}
                                  detailData={detailData}/>
            <WrkPrmtRgstModal setModalIsOpen={setWrkModalIsOpen} modalIsOpen={wrkModalIsOpen}
                              siteId={defaultUser?.blngSiteId || user.blngSiteId}
                              detailData={detailData}/>
            <RskAsmntRgstModal setModalIsOpen={setRskModalIsOpen} modalIsOpen={rskModalIsOpen} siteId={defaultUser?.blngSiteId || user.blngSiteId}
                               detailData={detailData}/>
            <DailySftyRprtRgstModal setModalIsOpen={setModalRgstIsOpen} modalIsOpen={modalRgstIsOpen} detailData={detailData} siteId={defaultUser?.blngSiteId || user.blngSiteId} />


            <Modal
                className="bmc-modal" size="lg"
                show={props.modalIsOpen}
                onShow={() => {
                    fn_onShow()

                }}
                onHide={fn_closeModal}
            >


                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        알림수신함
                        <IoMdClose className='hover:cursor-pointer' onClick={fn_closeModal}/>
                    </div>
                </Modal.Header>

                <Modal.Body className="px-4">

                    <div className="bmc-modal-div  h-[300px] overflow-y-auto overflow-x-hidden">
                        <div className="card-body">
                            <table
                                className="bmc-table-primary w-100 dataTable no-footer">
                                <thead>
                                <tr>
                                    <th className={'text-center'}>No</th>
                                    <th className={'text-center'}>구분</th>
                                    <th className={'text-center'}>상태</th>
                                    <th className={'text-center'}>제목</th>
                                    <th className={'text-center'}>등록일자</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    dataList.length > 0 ?
                                        dataList.map((data: any, idx:number) => (
                                            <tr key={idx} className={data.isRead ? 'fixedTop' : ''} onClick={() => fn_openDtlPop(data)}>
                                                <td className={'text-center'}>
                                                    {idx + 1}
                                                </td>
                                                <td className={'text-center'}>
                                                    {data.rcvNtfyGbNm}
                                                </td>
                                                <td className={'text-center'}>
                                                    {data.statusNm}
                                                </td>
                                                <td className={'text-center'}>
                                                    {data.title}
                                                </td>
                                                <td className={'text-center'}>
                                                    {data.rgstTime}
                                                </td>
                                            </tr>

                                        )) : <tr>
                                            <td colSpan={5} className={'text-center'}>수신 알림 내역이 없습니다.</td>
                                        </tr>
                                }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="py-2">
                    <div className='flex justify-center w-100'>
                        <button
                            className='bmc-btn pill l white me-3'
                            onClick={fn_closeModal}>닫기
                        </button>

                    </div>
                </Modal.Footer>


            </Modal>
        </div>
    )
}

export default RcvNtfyListModal;
